module.exports = __webpack_public_path__ + "static/img/Jaylan-De-Groot.d7d4782.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jaylan-De-Groot.jpg
// module id = qk3e
// module chunks = 0